import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

type SectionEditBtnProps = {
  onClick?: () => void;
  disabled?: boolean;
};
const SectionEditBtn = ({ onClick, disabled = false }: SectionEditBtnProps) => {
  const handleClick = () => {
    if (disabled) {
      return;
    }
    onClick?.();
  };

  return (
    <span
      className="clinical-obs__gene-edit-btn"
      onClick={handleClick}
      role="button"
      aria-disabled={disabled}
      tabIndex={disabled ? -1 : 0}
      style={disabled ? { opacity: 0.5, cursor: 'not-allowed' } : undefined}
    >
      <FontAwesomeIcon icon={faPencilAlt} />
    </span>
  );
};

export default SectionEditBtn;
